import * as React from "react";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
} from "@progress/kendo-react-grid";
import "./tablestyle.scss";
import { useEffect, useState } from "react";
import RatingTable from "./ratingTable"
import ContractTable from "./contractTable"
import AppliedJobsTable from "./appliedJobs";
import FulltimeTable from "./fulltimejobs";


interface AppState {
  items: any;
  total: number;
  skip: number;
  pageSize: number;
  pageable: GridPagerSettings;
}

const Table = (props: any) => {
  
  const [allocatedTo, setAllocatedTo] = useState<any>();


  const createState = (skip: number, take: number, items: any) => {
    let pagerSettings: GridPagerSettings = {
      buttonCount: 20,
      info: true,
      type: "numeric",
      pageSizes: [25, 50, 100],
      previousNext: true,
    };
    return {
      items: items,
      total: props.total && props.total,
      skip: skip,
      pageSize: take,
      pageable: pagerSettings,
    };
  };

  
  const [state, setState] = useState<AppState>(createState(0, 25, props.data));
  const [data, setData] = useState(state.items);

  useEffect(() => {
    if(state)
    {
      setState(createState(state.skip, state.pageSize, props.data));
      setData(state.items)
    }
  }, [props.total, props.data])
  

  useEffect(() => {

  }, [])
   
  return (
    <div className="tableStyle">
      {props && props.type === 'rating' && <RatingTable  data={props.data} sendReminder={props.sendReminder}/>  }
      {props && props.type === 'contract' && <ContractTable data={props.data} />}
      {props && props.type === 'appliedJobs' && <AppliedJobsTable  data={props.data}/>  }
      {props && props.type === 'fulltimeJobs' && <FulltimeTable  data={props.data}/>  }
    </div>
  );
};

export default Table;
